import React, { useState } from 'react';
import axios from 'axios';
import axiosInstance from '../../../utils/axiosInstance';
import { Link } from 'react-router-dom';

export default function AddProduct() {
  const [newProduct, setNewProduct] = useState({
    name: '',
    price: '',
    image: null, // Updated to use null for the image state
    description: '',
    iscake: false, // Initialize iscake as a boolean
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleInputChange = (fieldName, value) => {
    setNewProduct((prevNewProduct) => ({
      ...prevNewProduct,
      [fieldName]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewProduct((prevNewProduct) => ({
      ...prevNewProduct,
      image: file,
    }));
  };

  const addProduct = async () => {
    const token = localStorage.getItem('token');
    try {
      if (newProduct.name && newProduct.price && newProduct.image) {
        const formData = new FormData();
        formData.append('name', newProduct.name);
        formData.append('price', newProduct.price);
        formData.append('image', newProduct.image);
        formData.append('description', newProduct.description);
        formData.append('iscake', newProduct.iscake);

        const response = await axiosInstance.post('/api/products/add-products', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            token: `Bearer ${token}`,
          },
        });

        // Assuming the API returns the newly added product
        const addedProduct = response.data;

        console.log('Product added:', addedProduct);

        // Clear the input fields and close the popup
        setNewProduct({ name: '', price: '', image: null, description: '' });
        closePopup();
      } else {
        alert('Please fill in all fields.');
      }
    } catch (error) {
      console.error('Error adding product:', error);
    }
  };

  const formFields = [
    { name: 'name', type: 'text', placeholder: 'Product Name' },
    { name: 'price', type: 'number', placeholder: 'Price' },
    { name: 'image', type: 'file', placeholder: 'Upload Image' },
    { name: 'description', type: 'text', placeholder: 'description' },
  ];

  return (
    <div>
       <div className="bg-gray-800 py-2 px-4 rounded-md">
      <ul className="flex text-white">
        <li className="mr-2">
          <Link to="/admin/home" className="hover:text-amber-500 transition">
            Home
          </Link>
        </li>
        <li className="mr-2">/</li>
        <li className="mr-2">
          <Link to="/products" className="hover:text-amber-500 transition">
            Products
          </Link>
        </li>
      </ul>
    </div>
    

    <button onClick={openPopup} className="p-2 bg-amber-500 mt-5 text-white rounded flex items-center mb-4">
      <span className="mr-2">+</span> Add New Product
    </button>

    {isPopupOpen && (
      <div className="bg-gradient-to-r from-pink-100 via-red-200 to-yellow-500 p-8 rounded-md shadow-md fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <h2 className="md:text-3xl tet-2xl font-bold mb-6 text-white">Add New Product</h2>
      <div className="flex flex-col space-y-1">
        {formFields.map((field) => (
          <input
            key={field.name}
            type={field.type}
            name={field.name}
            placeholder={field.placeholder}
            value={field.type === 'file' ? undefined : newProduct[field.name]}
            onChange={(e) => (field.type === 'file' ? handleImageChange(e) : handleInputChange(field.name, e.target.value))}
            className="p-3 border-2 border-pink-400 rounded-md bg-white placeholder-gray-400 focus:outline-none focus:border-pink-500"
          />
        ))}
    
        <div className="flex items-center justify-between mt-6">
          <button onClick={addProduct} className="p-3 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 focus:outline-none focus:ring focus:border-yellow-700">
            Add Product
          </button>
          <button onClick={closePopup} className="p-3 bg-gray-700 text-white rounded-md hover:bg-gray-800 focus:outline-none focus:ring focus:border-gray-800">
            Close
          </button>
        </div>
      </div>
    </div>
    
    )}
  </div>
  );
}
